import { render, staticRenderFns } from "./erm2.vue?vue&type=template&id=23dbf698&"
import script from "./erm2.vue?vue&type=script&lang=js&"
export * from "./erm2.vue?vue&type=script&lang=js&"
import style0 from "./erm2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports